// Secure logging utility that only logs in development mode
// This prevents sensitive information from being exposed in production console

const isDevelopment = import.meta.env.MODE === 'development' || import.meta.env.DEV;

export const secureLog = {
  log: (...args: any[]) => {
    if (isDevelopment) {
      console.log(...args);
    }
  },
  error: (...args: any[]) => {
    if (isDevelopment) {
      console.error(...args);
    }
  },
  warn: (...args: any[]) => {
    if (isDevelopment) {
      console.warn(...args);
    }
  },
  info: (...args: any[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  }
};

// Safe error logging that doesn't expose sensitive data
export const safeErrorLog = (message: string, context?: string) => {
  if (isDevelopment) {
    console.error(`[${context || 'PublicReceipt'}] ${message}`);
  }
  // In production, we could send this to a secure logging service
  // Example: sendToSecureLoggingService(message, context);
}; 